import { useEffect, useState } from "react";
import { Modal, Form, Input, Button, Space } from "antd";
import { FolderOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import axiosInstance from "../../../variables/api/axiosInstance";

const { TextArea } = Input;

const AddBranche = ({
    show,
    handleClose,
    editMode = false,
    selectedBranche,
    existingBranches,
}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show) {
            if (editMode && selectedBranche) {
                form.setFieldsValue({
                    nom: selectedBranche.nom || "",
                    codeBranche: selectedBranche.codeBranche || "",
                    description: selectedBranche.description || "",
                });
            } else {
                form.resetFields();
            }
        }
    }, [show, editMode, selectedBranche, form]);

    const onSubmit = async (values) => {
        // Vérification des doublons
        const isDuplicateNom = existingBranches.some(
            (b) =>
                b.nom.toLowerCase() === values.nom.toLowerCase() &&
                (editMode ? b.brancheId !== selectedBranche.brancheId : true)
        );

        const isDuplicateCode = existingBranches.some(
            (b) =>
                b.codeBranche.toLowerCase() === values.codeBranche.toLowerCase() &&
                (editMode ? b.brancheId !== selectedBranche.brancheId : true)
        );

        if (isDuplicateNom) {
            toast.error("Une branche avec ce nom existe déjà.");
            return;
        }

        if (isDuplicateCode) {
            toast.error("Une branche avec ce code existe déjà.");
            return;
        }

        setLoading(true);

        const brancheData = {
            ...(editMode && { brancheId: selectedBranche.brancheId }),
            ...values,
        };

        try {
            if (editMode) {
                await axiosInstance.put(`/api/branche`, brancheData);
                toast.success("Branche modifiée avec succès");
            } else {
                await axiosInstance.post(`/api/branche`, brancheData);
                toast.success("Branche ajoutée avec succès");
            }
            form.resetFields();
            handleClose();
        } catch (err) {
            console.error(err);
            if (err.response && err.response.status === 409) {
                toast.error("Cette branche existe déjà sur le serveur.");
            } else {
                toast.error(
                    editMode
                        ? "Erreur lors de la modification"
                        : "Erreur lors de l'ajout"
                );
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            open={show}
            onCancel={() => {
                form.resetFields();
                handleClose();
            }}
            footer={null}
            width={600}
            title={
                <Space>
                    <FolderOutlined style={{ color: "#764ba2" }} />
                    <span style={{ fontSize: 18, fontWeight: 600 }}>
                        {editMode ? "Modifier la branche" : "Nouvelle branche"}
                    </span>
                </Space>
            }
        >
            <div style={{ padding: "8px 0" }}>
                <p style={{ color: "#666", marginBottom: 24 }}>
                    {editMode
                        ? "Modifiez les informations de la branche d'assurance"
                        : "Créez une nouvelle branche d'assurance pour organiser vos catégories"}
                </p>

                <Form form={form} layout="vertical" onFinish={onSubmit}>
                    <Form.Item
                        label="Nom de la branche"
                        name="nom"
                        rules={[
                            { required: true, message: "Le nom est requis" },
                            { min: 2, message: "Le nom doit contenir au moins 2 caractères" },
                        ]}
                    >
                        <Input
                            placeholder="Ex: Automobile, Santé, Vie..."
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Code de la branche"
                        name="codeBranche"
                        rules={[
                            { required: true, message: "Le code est requis" },
                            {
                                pattern: /^[A-Z0-9]+$/,
                                message: "Le code doit contenir uniquement des lettres majuscules et chiffres",
                            },
                        ]}
                    >
                        <Input
                            placeholder="Ex: AUTO, SANTE, VIE..."
                            size="large"
                            style={{ textTransform: "uppercase" }}
                        />
                    </Form.Item>

                    <Form.Item label="Description" name="description">
                        <TextArea
                            rows={4}
                            placeholder="Description optionnelle de la branche..."
                        />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
                        <Space style={{ width: "100%", justifyContent: "flex-end" }}>
                            <Button
                                onClick={() => {
                                    form.resetFields();
                                    handleClose();
                                }}
                                disabled={loading}
                            >
                                Annuler
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                                style={{
                                    background: "#764ba2",
                                    borderColor: "#764ba2",
                                }}
                            >
                                {editMode ? "Modifier" : "Créer"}
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default AddBranche;